<mat-dialog-content>
  <h2 mat-dialog-title>{{ 'USERS.RESEND_WELCOME_EMAIL_MODAL.TITLE' | translate }}</h2>
  <p>{{ 'USERS.RESEND_WELCOME_EMAIL_MODAL.CONTENT' | translate }}</p>
  <email-domain-chooser #domain [sender]="sender" emailSettingsRouterLink="/email-settings"></email-domain-chooser>
  <div class="market-container">
    <div class="market-description" *ngIf="marketName$ | async as marketName">
      <span class="market-id">{{ marketName }}</span>
      {{ 'USERS.RESEND_WELCOME_EMAIL_MODAL.MARKET_DESCRIPTION' | translate }}
    </div>
    <button mat-flat-button color="primary" class="preview-button" (click)="openPreviewEmail()">
      {{ 'USERS.RESEND_WELCOME_EMAIL_MODAL.PREVIEW' | translate }}
    </button>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>
    {{ 'USERS.RESEND_WELCOME_EMAIL_MODAL.SECONDARY_ACTION' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="resendWelcomeEmail(domain.getChoice())">
    {{ 'USERS.RESEND_WELCOME_EMAIL_MODAL.PRIMARY_ACTION' | translate }}
  </button>
</mat-dialog-actions>
